
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/giveaway/homestead-series",
      function () {
        return require("private-next-pages/[locale]/giveaway/homestead-series.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/giveaway/homestead-series"])
      });
    }
  